module.exports = __webpack_public_path__ + "img/armyJoystick.fcc5fcc9.png";